<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      {{ info.id ? "Cập nhật tính năng" : "Thêm mới" }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <ValidationProvider
                name="Tên tính năng"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  label="Tên tính năng"
                  :error="errors[0]"
                  v-model="info.name"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
              <b-textarea
                v-model="info.description"
                placeholder="Mô tả"
                rows="3"
              ></b-textarea>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng (Esc)
        </button>
        <button type="button" @click="doSave(1)" class="btn btn-success">
          Lưu tiếp (Shift + F4)
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { roleService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      info: {},
      ownInfo: {}
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        self.isPending = true;
        if (self.info.id) {
          roleService
            .updateFeature(self.info.id, self.info)
            .then(res => {
              self.ownInfo.name = self.info.name;
              self.ownInfo.description = self.info.description;
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(info) {
      this.ownInfo = info;
      this.info = Object.assign({}, info);
      delete this.info.rule;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
